import { reviewFormValidator } from "@redotech/redo-model/form-builder-form/db-validator/review/review-form-builder-form-validator";
import { z } from "zod";

export const getReviewFormsForTeam = {
  input: z.object({ teamId: z.string() }),
  output: z.array(reviewFormValidator),
};
